import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "first-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "second-list" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "third-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slicedItems, (menu, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!menu.disable)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: index,
                  to: menu.url
                }, {
                  default: _withCtx(() => [
                    (!menu.disable)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: _normalizeClass(["link", { 'selected-menu': _ctx.currentRoute.startsWith(menu.url) }]),
                          onClick: ($event: any) => (_ctx.handleClick($event, menu))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(menu.label), 1),
                          (menu.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: menu.img
                              }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true),
                          (menu.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: menu.img
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextSlicedItems, (menu, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!menu.disable)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: index,
                  to: menu.url,
                  target: menu.label === 'FileNet' ? '_blank' : '_self',
                  onClick: ($event: any) => (_ctx.handleClick($event, menu))
                }, {
                  default: _withCtx(() => [
                    (!menu.disable)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: _normalizeClass(["link", { 'selected-menu': menu.url === _ctx.currentRoute }])
                        }, [
                          _createElementVNode("span", null, _toDisplayString(menu.label), 1),
                          (menu.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: menu.img
                              }, null, 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to", "target", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.furtherSlicedItems, (menu, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!menu.disable)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: index,
                  to: menu.url
                }, {
                  default: _withCtx(() => [
                    (!menu.disable)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: index,
                          class: _normalizeClass(["link", { 'selected-menu': menu.url === _ctx.currentRoute } ]),
                          onClick: ($event: any) => (_ctx.handleClick($event, menu))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(menu.label), 1),
                          (menu.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: menu.img
                              }, null, 8, _hoisted_11))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ])
  ]))
}